import React, { useEffect } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import SvgIcon from "@Components/icons/SvgIcon";
import "./InstitutePayment.scss";
import { createInstitutePaymentOrder, institutePaymentCheck, instituteSubscriptionTopup, instituteTopupCheck, subscribeInstitutePlan } from "./services/InstitutePayment.service";
import { AppRouteURL } from "@Constants/app-route-url.constant";
import { useAppDispatch } from "@Src/app/hooks";
import { showSpinner } from "@Src/app/reducers/globalSlice";
import { toast } from 'react-hot-toast';
import { NoSubscriptionDialog } from "@Components/NoSubscriptionDialog/NoSubscriptionDialog";
import { ReactComponent as IabhyasLogo } from "@Src/assets/svg/iabhyas-logo.svg";
import { Skeleton } from "primereact/skeleton";

export const InstitutePayment = () => {
    const params: any = useParams();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const location = useLocation();

    const [planDetails, setPlanDetails] = React.useState<any>({});
    const [topupDetails, setTopupDetails] = React.useState<any>({});
    const [showSuccessDialog, setShowSuccessDialog] = React.useState(false);
    const [loading, setLoading] = React.useState(true);

    const CheckTokenValidity = async (payload: any) => {
        if (location.pathname.includes('institute-payment-topup')) {
            try {
                const topupResponse: any = await instituteTopupCheck(payload);
                if (topupResponse.ResponseType === 'SUCCESS' && topupResponse.data?.[0]) {
                    setTopupDetails(topupResponse.data[0]);
                    setLoading(false);
                } else {
                    setLoading(false);
                }
            } catch (error) {
                console.log(error);
                setLoading(false);
            }

        } else {
            try {
                const response: any = await institutePaymentCheck(payload);
                if (response.ResponseType === 'SUCCESS' && response.data?.[0]) {
                    setLoading(false);
                    setPlanDetails(response.data[0]);

                } else {

                    setLoading(false);
                }
            } catch (error) {
                console.log(error);
                setLoading(false);

            }
        }

    }
    useEffect(() => {
        if (!params?.id) {
            navigate('/');
        } else {
            CheckTokenValidity({ TokenId: params.id })
        }
    }, [params?.id])

    const priceNum = parseFloat(planDetails?.Price || '0');
    const formattedPrice = priceNum % 1 === 0 ? priceNum.toFixed(0) : planDetails?.Price;
    const formattedTopupPrice = topupDetails?.Price ? (parseFloat(topupDetails.Price) % 1 === 0 ? parseFloat(topupDetails.Price).toFixed(0) : topupDetails.Price) : '';

    const handleSubscribe = async () => {
        try {
            dispatch(showSpinner(true));
            const orderRes = await createInstitutePaymentOrder({ amount: !planDetails?.id ? formattedTopupPrice : formattedPrice });
            if (orderRes.ResponseType === 'SUCCESS' && orderRes?.data[0]?.amount) {
                dispatch(showSpinner(false));
                const options = {
                    key: process.env.REACT_APP_RAZORPAY_KEY_ID,
                    amount: orderRes.data[0].amount,
                    currency: orderRes.data[0].currency,
                    name: "Iabhyas",
                    description: "Test Payment",
                    order_id: orderRes.data.id,
                    handler: async function (response: any) {
                        try {
                            dispatch(showSpinner(true));
                            const subscribeRes = await (planDetails?.id ? subscribeInstitutePlan({ TokenId: params.id, Price: formattedPrice, OrderId: orderRes.data[0].id, PaymentId: response.razorpay_payment_id }) : instituteSubscriptionTopup({ TokenId: params.id, Price: formattedTopupPrice, OrderId: orderRes.data[0].id, PaymentId: response.razorpay_payment_id }));
                            if (subscribeRes.ResponseType === 'SUCCESS') {
                                setShowSuccessDialog(true);
                            } else {
                                toast.error(subscribeRes.StatusMsg || 'Subscription failed. Please contact support.');
                            }
                        } catch (error) {
                            console.error('Error during final subscription step:', error);
                            toast.error('An error occurred. Please contact support.');
                        } finally {
                            dispatch(showSpinner(false));
                        }
                    },
                    prefill: {
                        name: "",
                        email: "",
                        contact: "",
                    },
                    modal: {
                        ondismiss: function () {
                            dispatch(showSpinner(false));
                        }
                    },
                    theme: {
                        color: "#7A68E0",
                    },
                };

                const rzp = new (window as any).Razorpay(options);
                rzp.open();

            } else {
                dispatch(showSpinner(false));
                toast.error(orderRes.StatusMsg || 'Subscription failed. Please try again.');
            }
        } catch (error) {
            dispatch(showSpinner(false));
            toast.error('Subscription failed. Please try again.');
        }
    }

    if (!planDetails?.id && !location.pathname.includes('institute-payment-topup') || !topupDetails?.NoOfStudents && !topupDetails?.Price && location.pathname.includes('institute-payment-topup')) {
        return (
            <div className="institute-payment-container">
                {
                    loading ? <div className="payment-card-container">

                        {/* Header */}
                        <div className="tw-flex tw-items-center mt-5">
                            <Skeleton width="180px" height="80px" />
                        </div>

                        <div className="payment-card tw-flex tw-gap-4 mt-4">

                            {/* Left Section */}
                            <div className="left-section tw-flex-1">

                                {/* Logo */}
                                <div className="tw-flex tw-items-center tw-gap-2 mb-4">
                                    <Skeleton shape="circle" size="40px" />
                                    <Skeleton width="120px" height="20px" />
                                </div>

                                {/* Title */}
                                <Skeleton width="150px" height="25px" className="mb-3" />

                                {/* Price */}
                                <Skeleton width="100px" height="30px" className="mb-2" />

                                {/* Duration */}
                                <Skeleton width="200px" height="20px" className="mb-4" />

                                {/* Benefits */}
                                <Skeleton width="120px" height="20px" className="mb-3" />

                                <div className="tw-flex tw-flex-col tw-gap-3">
                                    <div className="tw-flex tw-items-center tw-gap-2">
                                        <Skeleton shape="circle" size="20px" />
                                        <Skeleton width="220px" height="15px" />
                                    </div>

                                    <div className="tw-flex tw-items-center tw-gap-2">
                                        <Skeleton shape="circle" size="20px" />
                                        <Skeleton width="180px" height="15px" />
                                    </div>
                                </div>
                            </div>

                            {/* Right Section */}
                            <div className="right-section tw-flex-1">

                                {/* Heading */}
                                <Skeleton width="120px" height="25px" className="mb-4" />

                                {/* Button */}
                                <Skeleton width="100%" height="45px" className="mb-3" />

                                {/* Disclaimer */}
                                <Skeleton width="100%" height="15px" className="mb-2" />
                                <Skeleton width="90%" height="15px" />
                            </div>

                        </div>
                    </div> : <div className="institute-subscription-invalid-page-wrapper">
                        <div className="ia-container tw-text-center  py-8">
                            <div className="tw-flex tw-justify-center tw-items-center mt-5 mb-3">
                                <div className="header-logo">
                                    <Link to='/'>
                                        <IabhyasLogo className="iabhyas-logo" style={{ height: '80px' }} />
                                    </Link>
                                </div>


                            </div>
                            <h1 className="tw-text-2xl tw-font-bold mb-4">Invalid Payment Link</h1>
                            <button className="ia-btn ia-btn-primary" onClick={() => navigate('/')}>
                                Go to home
                            </button>
                        </div>
                    </div>
                }
            </div>

        );
    }
    return (
        <div className="institute-payment-container">



            <div className="payment-card-container">
                <div className="tw-flex tw-items-center mt-5">
                    <div className="header-logo">
                        <Link to='/'>
                            <IabhyasLogo className="iabhyas-logo" style={{ height: '80px' }} />
                        </Link>
                    </div>


                </div>
                <div className="payment-card">
                    {/* Left Section */}
                    <div className="left-section">

                        <div className="logo-container" onClick={() => navigate("/")} style={{ cursor: 'pointer' }}>
                            <div className="logo-icon">
                                <SvgIcon name="crown" size={20} />
                            </div>
                            <span className="logo-text">iabhyas</span>
                        </div>

                        <div className="pay-text">{planDetails.id ? `Pay iabhyas` : `Top-up`}</div>
                        {planDetails.id && (
                            <>
                                <div className="price">₹{formattedPrice}</div>
                                <p className="duration">
                                    Duration - {planDetails.Duration} {planDetails.PlanUom?.charAt(0).toUpperCase() + planDetails.PlanUom?.slice(1)}{planDetails.Duration > 1 ? 's' : ''}
                                </p>

                                <div className="benefits-section">
                                    <h3>BENEFITS</h3>
                                    <ul>
                                        <li>
                                            <span className="check-icon">
                                                <SvgIcon name="tick" size={16} />
                                            </span>
                                            Mocktests Per Student - {planDetails.NumberOfMocktests}
                                        </li>

                                        {
                                            planDetails.ShowAnalytics === 1 &&
                                            <li>
                                                <span className="check-icon">
                                                    <SvgIcon name="tick" size={16} />
                                                </span>
                                                Performance Analysis and Tips
                                            </li>
                                        }
                                    </ul>
                                </div>
                            </>
                        )}
                        {
                            topupDetails.Price && topupDetails.NoOfStudents && (
                                <div className="topup-details">
                                    <div className="price">₹{formattedTopupPrice}</div>
                                    <p className="duration">No. of Students - {topupDetails.NoOfStudents}</p>
                                </div>
                            )
                        }
                    </div>

                    {/* Right Section */}
                    <div className="right-section">
                        <h2>Payment</h2>

                        {/* Button */}
                        <button className="subscribe-btn" onClick={handleSubscribe}>
                            Subscribe
                        </button>

                        <div className="disclaimer">
                            By confirming your subscription, you allow iabhyas to charge your card
                            for this payment and future payments in accordance with their terms.
                        </div>
                    </div>
                </div>

            </div>
            <NoSubscriptionDialog
                visible={showSuccessDialog}
                onHide={() => {
                    setShowSuccessDialog(false);
                    navigate('/');
                }}
                heading="You have subscribed successfully"
                message=" "
                showSubscribeButton={false}
                primaryButtonText="Ok"
                position="center"
            />


        </div>
    );
};
